import React, { useContext } from "react";
import Content from "../../../i18n/content.js";
import {
    messageButton,
    messageText,
    popup,
    popupMessage,
} from "./PopupMessage.css.js";

interface Props {
    onReset: () => void;
}
const PopupMessage: React.FC<Props> = ({ onReset }) => {
    const {
        productSupportPage: { popupMsgText, okBtn },
    } = useContext(Content);
    return (
        <div className={popup}>
            <div className={popupMessage}>
                <p className={messageText}>{popupMsgText}</p>
                <button onClick={onReset} className={messageButton}>
                    {okBtn}
                </button>
            </div>
        </div>
    );
};

export default PopupMessage;
